import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-class',
	templateUrl: './icon-class.component.svg',
})
export class IconClassComponent {}
